import React, { useEffect, useState } from "react";
import Line from "assets/Icons/Line.svg";
import ExpandIcon from "assets/Icons/replenishment/ExpandIcon.svg";
import CompactColumn from "assets/Icons/replenishment/CompactColumn.svg";
import StandardColumn from "assets/Icons/replenishment/StandardColumn.svg";
import ComfortableColumn from "assets/Icons/replenishment/ComfortableColumn.svg";
import UploadIcon from "assets/Icons/replenishment/UploadIcon.svg";
import ColumnDensity from "components/Table/components/ColumnDensity";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "store/types";
import { GridDensity } from "@mui/x-data-grid-pro";
import { Box } from "@mui/material";
import UploadModal from "components/Table/components/UploadModal";
import { expandTable } from "store/table/table.slice";

interface StateProps {
  expand: boolean;
  density: string;
  columns: boolean;
  densityVisible: boolean;
  editAll: boolean;
  upload: boolean;
}

const menuContainerStyles = {
  backgroundColor: "#002B49",
  height: "36px",
  width: "fit-content",
  padding: "0 8px",
  borderRadius: "8px 8px 0px 0px",
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  gap: "12px",
  paddingBottom: "4px",
  position: "absolute",
  left: 0,
  right: 0,
  top: "-40px",
  margin: "0 auto",
};

const menuIconStyles = {
  cursor: "pointer",
};

const lineStyle = {
  marginTop: "8px",
};

const ExpandedMenu = ({
  disableUpload,
  widgetName,
  disableExpand,
  getState,
  callback,
}: {
  disableUpload?: boolean;
  widgetName?: string;
  disableExpand?: boolean;
  getState?: (state: boolean) => void;
  callback?: Function;
}) => {
  const dispatch = useDispatch();

  const density = useSelector(
    (state: AppState) => state.table.density
  ) as GridDensity;
  const expand = useSelector((state: AppState) => state.table.expand);
  const [state, setState] = useState<StateProps>({
    expand: false,
    density: "",
    columns: false,
    densityVisible: false,
    editAll: false,
    upload: false,
  });
  const handleChangeDensityVisibility = () => {
    setState({ ...state, densityVisible: !state.densityVisible });
  };

  const handleChangeTableExpand = () => {
    dispatch(expandTable(!expand));
    // setState({ ...state, expand: !state.expand });
  };

  useEffect(() => {
    setState({ ...state, densityVisible: false });
  }, [density]);

  const handleClose = (
    event: {},
    reason: "backdropClick" | "escapeKeyDown"
  ) => {
    if (reason === "backdropClick") {
      console.log(reason);
    } else {
      setState({ ...state, upload: false });
    }
  };

  const openUpload = () => {
    if (callback) {
      //When callback is used UploadModal component is assumed to be called from the callback source
      callback();
    } else {
      setState({ ...state, upload: true });
    }
  };

  useEffect(() => {
    if (getState) getState(state.upload);
  }, [state.upload]);

  return (
    <>
      <Box sx={menuContainerStyles}>
        {!disableUpload && (
          <>
            <img
              src={UploadIcon}
              alt="upload"
              style={{
                marginLeft: "4px",
                marginTop: "4px",
                cursor: "pointer",
              }}
              onClick={openUpload}
            />

            <span style={lineStyle}>
              <img src={Line} alt="line" style={{ height: "32px" }} />
            </span>
          </>
        )}

        <Box
          sx={{
            borderRadius: "4px",
            padding: "4px",
            background: "rgba(220, 227, 235, 0.3)",
            marginTop: "4px",
          }}
        >
          <span style={menuIconStyles}>
            <img
              src={
                density === "standard"
                  ? StandardColumn
                  : density === "comfortable"
                  ? ComfortableColumn
                  : CompactColumn
              }
              alt="column"
              onClick={handleChangeDensityVisibility}
            />
          </span>
        </Box>
        {!disableExpand && (
          <>
            <span style={lineStyle}>
              <img src={Line} alt="line" style={{ height: "32px" }} />
            </span>
            <Box
              sx={{
                borderRadius: "4px",
                padding: "4px",
                background: expand ? "rgba(220, 227, 235, 0.3)" : "none",
                marginTop: "4px",
              }}
            >
              <img
                src={ExpandIcon}
                alt="expandIcon"
                style={menuIconStyles}
                onClick={handleChangeTableExpand}
              />
            </Box>
          </>
        )}
      </Box>
      {state.densityVisible && <ColumnDensity />}
      {state.upload && (
        <UploadModal
          //@ts-ignore
          handleClose={handleClose}
          open={state.upload}
          widgetName={widgetName}
        />
      )}
    </>
  );
};

export default ExpandedMenu;
